// ─── Assistant Prompts (Chat History & Favorites) Action Types ────────────────

export const ASSISTANT_PROMPTS_TYPES = {
  TOGGLE_PANEL:       "ASSISTANT_PROMPTS_TOGGLE_PANEL",
  SET_ACTIVE_TAB:     "ASSISTANT_PROMPTS_SET_ACTIVE_TAB",
  ADD_RECENT:         "ASSISTANT_PROMPTS_ADD_RECENT",
  SET_FAVORITES:      "ASSISTANT_PROMPTS_SET_FAVORITES",
  TOGGLE_FAVORITE:    "ASSISTANT_PROMPTS_TOGGLE_FAVORITE",
  PATCH_REQUEST:      "ASSISTANT_PROMPTS_PATCH_REQUEST",
  PATCH_SUCCESS:      "ASSISTANT_PROMPTS_PATCH_SUCCESS",
  PATCH_FAILURE:      "ASSISTANT_PROMPTS_PATCH_FAILURE",
  FETCH_REQUEST:      "ASSISTANT_PROMPTS_FETCH_REQUEST",
};

// ─── Action Creators ──────────────────────────────────────────────────────────

export const toggleAssistantPanel = () => ({
  type: ASSISTANT_PROMPTS_TYPES.TOGGLE_PANEL,
});

export const setActiveTab = (tab) => ({
  type: ASSISTANT_PROMPTS_TYPES.SET_ACTIVE_TAB,
  payload: tab,
});

export const addRecentPrompt = (text) => ({
  type: ASSISTANT_PROMPTS_TYPES.ADD_RECENT,
  payload: text,
});

export const setFavorites = (customdata) => ({
  type: ASSISTANT_PROMPTS_TYPES.SET_FAVORITES,
  payload: customdata,
});

export const toggleFavoritePrompt = (text) => ({
  type: ASSISTANT_PROMPTS_TYPES.TOGGLE_FAVORITE,
  payload: text,
});

export const patchCustomdata = (payload) => ({
  type: ASSISTANT_PROMPTS_TYPES.PATCH_REQUEST,
  payload,
});

export const fetchAssistantPrompts = () => ({
  type: ASSISTANT_PROMPTS_TYPES.FETCH_REQUEST,
});
